export const dynamicScopedSlots = (scopedSlots, filterString) => {
    return Object.fromEntries(
        Object.entries(scopedSlots).filter(([key]) => key.includes(filterString))
    )
}

export const filterProps = (props, removeThisPropKeys) => {
    return Object.fromEntries(Object.entries(props).filter(([key]) => {
        return !removeThisPropKeys.includes(key);
    }))
}
